import { initOnce } from '@/generic/init';
import { inject } from '@/supporting/account/injections.ts';
import { USERS_REPOSITORY } from '@/supporting/account/AccountKeys.ts';
import { provideAccount } from '@/supporting/account/AccountProvider.ts';

const ACCOUNT_KEY = Symbol('Account');

export { Authorities } from '@/supporting/account/domain/Authorities.ts';
export { type Authority, RULE_IMPORT } from '@/supporting/account/domain/Authority.ts';
export { Organization } from '@/supporting/account/domain/Organization.ts';
export { OrganizationId } from '@/supporting/account/domain/OrganizationId.ts';
export { User } from '@/supporting/account/domain/User.ts';
export { WithoutOrganization } from '@/supporting/account/domain/WithoutOrganization.ts';
export type { UsersRepository } from '@/supporting/account/domain/UsersRepository.ts';

export const initAccount = () => {
  initOnce(ACCOUNT_KEY, provideAccount);

  return {
    injectUsersRepository: () => inject(USERS_REPOSITORY),
  };
};
